import type { AppState } from '@store/types'

export const migrationArtBoardSelectors = {
  getIsEmbed: (state: AppState) => state.artboard.isEmbed,
  getIsShowAiChat: (state: AppState): boolean => state.artboard.showAiChat,
}
